module.exports = __webpack_public_path__ + "img/undraw_awesome.svg";